<app-sidebar [secNavOpen]="false" [awardsSelectedCategory]="awardSelection"
    (selectedCategory)="onSelectIndex($event)"></app-sidebar>
<div class="main-cotainer">
    <div class="awrd-container">
        <div class="menu-container">
        </div>
        <div class="awards-container">
            <!-- <nav class="navbar navbar-expand-lg navbar-light cus-nav-bar navbar-fixed-top">
            </nav> -->

            <div class="content mt-4 ml-6" fxHide.xs>
                <div style="display: flex;flex-direction: row;justify-content: space-between;">
                    <div style="display: flex;flex-direction: column;">
                        <h1 class="awards-title">{{headerName}}</h1>
                        <div class="header-border mb-4"></div>
                    </div>

                    <div class="form-floating" *ngIf="isArchive">
                        <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                            aria-label="Floating label select example" (change)="onChangeVersion($event)">
                            <option value="">Choose Version</option>
                            <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}
                            </option>
                        </select>
                        <label for="floatingSelect" class="value-label">Choose Version</label>
                    </div>
                </div>
                <div class="fxlineup" fxLayout="row wrap" fxLayoutGap="22px grid" fxFlex.md="100"
                    style="justify-content: center;align-items: center;" *ngIf="allWinners.length">

                    <div fxFlex="33.3333%" *ngFor="let item of allWinners" fxFlex.sm="50%" fxFlex.md="30%"
                        fxFlex.lt-lg="50%" fxFlex.gt-xs="33%" fxFlex.gt-lg="33%">
                        <div class="divLineup" style="background-color: #D7BE69;">
                            <span>
                                <img class="image" src="{{item.thumbnail}}" />
                            </span>
                            <h3 class="spotlightsDate" [title]="item.award">
                                {{item.award}} </h3>
                            <h3 class="spotLightsTitle">{{item.winner}}</h3>
                            <div class="spotlight_button" fxLayoutGap="10px">
                                <button id="btn3" (click)="goToLink(item.movie_link)">More Info</button>

                            </div>
                        </div>

                    </div>

                </div>
                <div *ngIf="!allWinners.length" class="nowinner">
                    <span>No Award Winners Found For the selected version.</span>
                </div>
            </div>
            <!-- <div class="all-awardees-custom">
                <h1 class="awards-title">{{headerName}}</h1>
                <div fxLayout="row wrap" class="g-2 ml-2">
                    <div class="col mt-4 awardess-col" *ngFor="let item of allWinners">
                        <div class="card">
                            <img class="card-img-top" [src]="item.thumbnail" alt="Card image cap"
                                style="height: 180px;">
                            <div class="card-body">
                                <h5 class="card-title" [title]="item.award">{{item.award}}</h5>
                                <p class="card-text" [title]="item.winner">{{item.winner}}</p>
                                <div class="btn btn-light" style="margin-top: 30px;"
                                    (click)="goToLink(item.movie_link)">More Info</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="all-awardees-custom-mobile mb-4">
                <div class="row g-2 ml-2">
                    <div style="display: flex;flex-direction: row;">
                        <h1 class="awards-title">All awardees</h1>
                        <div class="form-floating" *ngIf="isArchive">
                            <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                            aria-label="Floating label select example" (change)="onChangeVersion($event)">
                            <option value="">Choose Award Version</option>
                            <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}
                            </option>
                        </select>
                        <label for="floatingSelect" class="value-label">Choose Version</label>
                        </div>

                    </div>
                    <div class="mobile-tabs">
                        <div (click)="onSelectIndex(0)"
                            [ngStyle]="selectedCategory == 0 ? {'color': '#D7BE69', 'text-decoration': 'underline'} : {'color': 'white',  'text-decoration': 'none'}">
                            All</div>
                        <div (click)="onSelectIndex(1)"
                            [ngStyle]="selectedCategory == 1 ? {'color': '#D7BE69', 'text-decoration': 'underline'} : {'color': 'white' , 'text-decoration': 'none'}">
                            Audience</div>
                        <div (click)="onSelectIndex(2)"
                            [ngStyle]="selectedCategory == 2 ? {'color': '#D7BE69', 'text-decoration': 'underline'} : {'color': 'white' , 'text-decoration': 'none'}">
                            Jury</div>
                    </div>
                    <div class="col mt-3 awardess-col" *ngFor="let item of allWinners">
                        <div class="card" style="width: 95vw;display: flex;flex-direction: row;"
                            (click)="goToLink(item.movie_link)">
                            <img class="card-img-top" [src]="item.mobile_thumbnail" alt="Card image cap" style="width: 130px;
                            height: 120px;
                            min-width: 130px;
                            max-width: 130px;">
                            <div class="card-body">
                                <p class="card-text" [title]="item.award">{{item.winner}}</p>
                                <h5 class="card-title" [title]="item.winner">{{item.award}}</h5>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>